export default __webpack_public_path__ + "static/media/before-after.365842cd.png";